import { Fish, Target, ShieldAlert, MessageCircle, ShoppingBag } from "lucide-react";

const RULES = [
  {
    icon: MessageCircle,
    title: "Keep it civil",
    body: "Disagreements are fine. Personal attacks, threats, hate speech, and harassment aren't. Argue rigs and boats all day — attack the argument, not the angler.",
  },
  {
    icon: Fish,
    title: "Post like a local",
    body: "Reports, questions, gear talk, and boasts are all welcome. Don't spam the same post across every category, and don't drop hot spots that ruin someone's honey hole.",
  },
  {
    icon: Target,
    title: "Follow Florida law",
    body: "That means FWC regs on seasons, bag limits, and protected species. Never post kills of gamefish or protected wildlife taken illegally. Poaching bragging gets you removed on the spot.",
  },
  {
    icon: ShoppingBag,
    title: "Marketplace ethics",
    body: "Only list gear you actually own and have the right to sell. Accurate photos, honest condition, real pickup location. No stolen goods. No live wildlife.",
  },
  {
    icon: ShieldAlert,
    title: "Firearms & ammo",
    body: "Any firearm, suppressor, NFA item, or regulated ammo sale must comply with federal, Florida, and local law — including background checks and FFL transfers where required. If it can't be sold legally on Facebook Marketplace, it can't be sold here either.",
  },
  {
    icon: ShieldAlert,
    title: "Prohibited items",
    body: "No protected species, live wildlife, drugs, tobacco, alcohol, counterfeits, stolen property, or anything else illegal to sell in Florida.",
  },
];

export default function Rules() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 animate-fade-in" data-testid="rules-page">
      <div className="text-xs uppercase tracking-widest text-accent mb-2">The house rules</div>
      <h1 className="font-display font-extrabold text-4xl md:text-5xl">Community Rules</h1>
      <p className="text-muted-foreground mt-3 max-w-2xl leading-relaxed">
        This is a community built on trust between Florida sportsmen. A few ground rules keep it that way. Breaking
        them gets your post removed. Breaking them repeatedly gets your account removed.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-10">
        {RULES.map((r, i) => {
          const Icon = r.icon;
          return (
            <div
              key={i}
              className="bg-card border border-border rounded-md p-5 shadow-[0_4px_24px_rgba(27,77,62,0.04)]"
              data-testid={`rule-card-${i}`}
            >
              <div className="w-10 h-10 rounded-md bg-primary/10 text-primary flex items-center justify-center">
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-bold text-lg mt-3">{r.title}</h3>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{r.body}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-12 border-l-4 border-secondary bg-secondary/5 p-5 rounded-r-md">
        <h3 className="font-display font-bold text-lg">Reporting</h3>
        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
          Every listing and thread has a <strong>Report</strong> button. Use it — mods review reports and act on them.
          Anonymous to the reported user.
        </p>
      </div>

      <div
        className="mt-6 rounded-md p-6 text-white"
        style={{ background: "hsl(218 62% 24%)" }}
        data-testid="rules-2a-statement"
      >
        <div className="patriot-band mb-4 rounded" aria-hidden />
        <h3 className="font-display font-bold text-xl">A word on the Second Amendment</h3>
        <p className="text-sm text-white/85 mt-2 leading-relaxed max-w-3xl">
          Florida Sportsman is a proud supporter of the Second Amendment and the National Rifle Association. We
          believe the right to keep and bear arms is fundamental — and that it comes with the responsibility to
          exercise it lawfully. Every firearm listed here must comply with federal, Florida, and local law. The
          buyer and seller assume all liability for each transaction. We are not liable for anyone's illegal actions.
        </p>
      </div>
    </div>
  );
}
